export default {
  // EE-only
  methods: {
    extraIssueInput: () => {},
  },
};
